import { TextField, Box, Button, FormControl, Autocomplete } from "@mui/material";
import { Localized } from "@fluent/react";
import { useState } from "react";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { ParcialUser } from "../../types/model";

interface AlarmGroupUserAdderUIProps {
	loading: boolean;
	assignableUsers: ParcialUser[];
	onAdd: (users: ParcialUser[]) => void;
}

export default function AlarmGroupAddUI(props: AlarmGroupUserAdderUIProps) {
	// Adding local state because handling the output of <Autocomplete>
	// Seems quite hard to to with the event alone
	const [users, setUsers] = useState<ParcialUser[]>([]);

	function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
		if(users.length > 0){
			props.onAdd(users);
		}
	}

	function disable() {
		if(users.length === 0) {
			return true
		}
		return false;
	}


	if(props.loading){
		return (<></>)
	} else {
		return (
		<>
			{/* Inline Form */}
			<form 
				onSubmit={(e) => handleSubmit(e)}
			>
				{/* Always use "alignItems: "stretch" on an inline form */}
				<Box sx={{ display: "flex", alignItems: "stretch" }}>
					<FormControl sx={{ flexGrow: 1 }}>
						<Localized
							id="alarm-group-adder-group-name-label"
							attrs={{ label: true }}
						>
							<Autocomplete
								multiple
								id="size-medium-standard-multi"
								size="small"
								options={props.assignableUsers}
								getOptionLabel={(option) => option.given_name}
								onChange={(event, value) => setUsers(value)}
								renderInput={(params) => (
									<Localized 
										id="alarm-group-add-user-autocomplete"
										attrs={{ 
											label: true, 
											placeholder: false 
										}}
									>
										<TextField
											{...params}
											variant="standard"
										/>
									</Localized>	
								)}
							/>
						</Localized>
					</FormControl>
					<Localized id="alarm-group-user-adder">
						<Button
							type="submit"
							variant="outlined"
							startIcon={<ControlPointIcon />}
							disabled={disable()}
						>
							{/* Localized */}
						</Button>
					</Localized>
				</Box>
			</form>
		</>
		);
	}
}
